import styles from './Modal.module.scss';
import { forwardRef } from 'react';

export const Modal = forwardRef(({children, className, modal, subClassName, close, disable}: any, ref: any) => {
  return (
    <div
      className={`${disable ? styles.disable : styles.modal} ${className}`}
      onClick={() => {
        close && close();
      }}
    >
      {modal ? (
        <div
          className={`${styles.modalContent} ${subClassName}`}
          ref={ref}
          onClick={(e) => {
            close && e.stopPropagation();
          }}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
});